import { createReducer, on } from '@ngrx/store';
import { ICostCentersState, initialCostCentersState, TCostCenters } from './costCenters.state';
import { CostCentersError, CostCentersLoaded, CostCentersLoading } from './costCenters.actions';

export const initialState: ICostCentersState = {
  costCenters: [],
  loading: false,
};

const setCostCenters = (
  state: ICostCentersState,
  { costCenters }: { costCenters: TCostCenters[] }
): ICostCentersState => ({
  ...state,
  costCenters,
  loading: false,
});

const _costCentersReducer = createReducer<ICostCentersState>(
  initialState,

  on(CostCentersLoading, (state) => ({
    ...state,
    loading: true,
  })),

  on(CostCentersLoaded, setCostCenters),

  on(CostCentersError, (state) => ({
    ...state,
    loading: false,
  }))
);

export function costCentersReducer(
  state: ICostCentersState | undefined,
  action: any
): ICostCentersState {
  return _costCentersReducer(state, action);
}
